import produce from "immer";
import { LoadState } from "../../constants/enums";
import { initialSupportTicket, initialSupportState } from "./defaultState";
import { ISupportState } from "./support.types";
import {
  FETCH_SUPPORT_TICKET_LIST_PROGRESS,
  FETCH_SUPPORT_TICKET_LIST_SUCCESS,
  FETCH_SUPPORT_TICKET_LIST_FAILED,
  FETCH_SUPPORT_TICKET_PROGRESS,
  FETCH_SUPPORT_TICKET_SUCCESS,
  FETCH_SUPPORT_TICKET_FAILED,
  CLEAR_SUPPORT_TICKET_STATE,
} from "./supportActions";

export const supportReducer = (
  state: ISupportState = initialSupportState,
  action: any
) => {
  switch (action.type) {
    // List Actions
    case FETCH_SUPPORT_TICKET_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
    }

    case FETCH_SUPPORT_TICKET_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = data;
        draftState.list.totalRecords = totalRecords;
        draftState.list.error = null;
      });
    }

    case FETCH_SUPPORT_TICKET_LIST_FAILED: {
      const { errorMessage } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.error = errorMessage;
      });
    }

    // Single Support Ticket Actions
    case FETCH_SUPPORT_TICKET_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.supportTicket.loading = LoadState.InProgress;
        draftState.supportTicket.data = initialSupportTicket;
      });
    }

    case FETCH_SUPPORT_TICKET_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.supportTicket.loading = LoadState.Loaded;
        draftState.supportTicket.data = data;
        draftState.supportTicket.error = null;
      });
    }

    case FETCH_SUPPORT_TICKET_FAILED: {
      return produce(state, (draftState) => {
        draftState.supportTicket.loading = LoadState.Failed;
      });
    }

    case CLEAR_SUPPORT_TICKET_STATE: {
      return produce(state, (draftState) => {
        draftState.supportTicket.data = initialSupportTicket;
      });
    }

    default: {
      return state;
    }
  }
};
